import UnknownRoute from "discourse/routes/unknown";

export default UnknownRoute.extend({
  templateName: "unknown",
});
